import axios from "axios";
import { api } from "~/router/apiConfig";

export function create(contractId, request) {
  return axios.post(
    api.path("siteQuickMode.store", { contractId: contractId }), request
  );
}

export function index(contractId) {
  return axios.get(api.path("siteQuickMode.index", { contractId: contractId }));
}
